import 'picturefill';
import 'popper.js';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';
import './karrier';
import './menu';
import './typer';
import './accordion';
import './customer-journey';
import './slider-partners';
import './slider-other-services-list';
import './slider-services';
import './ajax-post';
import './social-sticky';
import './flowchart';
import './slider-coworkers';
import './smooth';
import './focus';
import './cf7';
import './acceptance';
import './maps';

import debounce from "./debounce";

$(() => {
	var $container = $('.motivation-hexagons'),
		$count = $container.data('count'),
		$hexaItemW = $('.motivation-hexagon').outerWidth(),
		$hexaItemH = $('.motivation-hexagon').outerHeight(),
		containerW = ($hexaItemW * $count) - (($count - 1) * 38),
		containerH = ($hexaItemH * 1.5);

	if (window.matchMedia('(min-width: 768px) and (max-width: 1199px)').matches) {
		containerW = ($hexaItemW * 4) - ((4 - 1) * 38);
		containerH = ($hexaItemH * 2.5);
	}
	if (window.matchMedia('(min-width: 768px)').matches) {
		$container.css('max-width', containerW).css('min-height', containerH);
	}

	$(window).resize(debounce(() => {
		if (window.matchMedia('(min-width: 768px) and (max-width: 1199px)').matches) {
			containerW = ($hexaItemW * 4) - ((4 - 1) * 38);
			containerH = ($hexaItemH * 2.5);
			// console.log('max-width');
			$container.css('max-width', containerW).css('min-height', containerH);
		}
		if (window.matchMedia('(min-width: 1200px)').matches) {
			containerW = ($hexaItemW * $count) - (($count - 1) * 38);
			containerH = ($hexaItemH * 1.5);
			// console.log('min-width');
			$container.css('max-width', containerW).css('min-height', containerH);
		}
	}, 100));

});



// WEBPACK FOOTER //
// ./assets/scripts/main.js